import { Button, Tooltip, mergeClasses } from "@fluentui/react-components";
import {
  useSharedCircleButtonStyles,
  useSharedDialogFooterStyles,
} from "theme/sharedStyles";
import { IDialogFooterActionProps } from "./DialogFooterAction.types";

export const DialogFooterAction = (
  props: IDialogFooterActionProps,
): JSX.Element => {
  const circleStyles = useSharedCircleButtonStyles();
  const footerStyles = useSharedDialogFooterStyles();
  const {
    icon,
    onClick,
    disabled,
    dimmed,
    tooltip,
    ariaLabel,
    ariaHidden,
    tabIndex,
    className,
  } = props;

  return (
    <Tooltip content={tooltip} relationship="label">
      <Button
        appearance="outline"
        icon={icon}
        onClick={onClick}
        disabled={disabled}
        aria-hidden={ariaHidden || undefined}
        tabIndex={tabIndex}
        className={mergeClasses(
          circleStyles.circleButton,
          dimmed && footerStyles.buttonDimmed,
          className,
        )}
        aria-label={ariaLabel ?? tooltip}
      />
    </Tooltip>
  );
};
